import { useContext } from 'react';
import type { RootState } from '../../grid/reduxStore/Store';
import { useAppDispatch } from '../../grid/reduxStore/Store';
import { SelectionContext } from '../SelectedBlockInfoProvider';
import { setActiveSidePanel, setIsAdvancedSpacingModelOpen, setIsReplaceModeActive } from '../../grid/reduxStore/blockStyleSettingsSlice';
import { useSectionId } from '../../Sections/SectionIdProvider';
import { useBlockStyleSettings } from '../../hooks/useBlockSettings';
import { GridBlockType } from 'services/entities/BlockTypes';
import { useSelector } from 'react-redux';
import { TableSettingsTypes } from 'components/editor/SidePanel/content/TableSettings/types';
import { EditorDefaultSidePanelType } from '../../grid/reduxStore/blockStyleSettingsSlice';
import useDeferredDispatch from '../../hooks/useDeferredDispatch';

export function useOpenBlockSettings() {
  const dispatch = useAppDispatch();
  const deferredDispatch = useDeferredDispatch();
  const { selectedBlockInfoByWrapper = { blockId: null, sectionId: null }, setSelectedBlockInfoByWrapper } = useContext(SelectionContext);
  const { activeSidePanel } = useSelector((state: RootState) => state.blockStyleSettings);
  const { addBlock } = useBlockStyleSettings();
  const sectionId = useSectionId();

  const closeBlockSettings = () => {
    dispatch(setIsAdvancedSpacingModelOpen(false));
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.EDITOR_DEFAULT_SIDE_PANEL }));
  };

  const openBlockSettings = (type: GridBlockType, blockId: string) => {
    if (selectedBlockInfoByWrapper.blockId === blockId && activeSidePanel === GridBlockType[type]) {
      return;
    }

    setSelectedBlockInfoByWrapper({ blockId, sectionId });
    deferredDispatch(setActiveSidePanel({ type: GridBlockType[type] }), setIsAdvancedSpacingModelOpen(false));
    const isShapeBlockType = type === GridBlockType.SHAPE;
    if (blockId) addBlock(blockId, isShapeBlockType);
  };

  const openImageLibraryPanel = (blockId: string | null) => {
    setSelectedBlockInfoByWrapper({ blockId, sectionId });
    dispatch(setActiveSidePanel({ type: EditorDefaultSidePanelType.UPLOADS_LIBRARY_PANEL }));
    dispatch(setIsReplaceModeActive(true));
    dispatch(setIsAdvancedSpacingModelOpen(false));
    if (blockId) addBlock(blockId);
  };

  const openTableDefaultSettings = (blockId: string | null) => {
    setSelectedBlockInfoByWrapper({ blockId, sectionId });
    dispatch(setActiveSidePanel({ type: TableSettingsTypes.TABLE_DEFAULTS }));
    dispatch(setIsAdvancedSpacingModelOpen(false));
  };

  return {
    openBlockSettings,
    closeBlockSettings,
    openImageLibraryPanel,
    openTableDefaultSettings,
  };
}
